import { useMemo } from 'react';
import { Case, CaseStatus, ClinicalItemType } from '@/api/apis/case';
import { getClinicalRecordByType, formatDateTimeStringToTimeZone, isAllowedStatus } from '@/utils/helpers';

export const useDonorEta = (caseData: Case, hasEditPermission: boolean) => {
  const { clinicalData, status, donorHospitalTime, donorHospitalDate, donorHospitalTimeZone } = caseData;

  const delayRecord = getClinicalRecordByType(clinicalData, ClinicalItemType.RecordDelay);
  const delayInfo = delayRecord?.items?.[0];
  const formatedDelay = formatDateTimeStringToTimeZone(delayInfo?.timestamp, delayInfo?.timeZone);

  const displayDelay =
    isAllowedStatus({ statusTo: CaseStatus.Closed, currentStatus: status }) &&
    hasEditPermission &&
    delayInfo !== undefined;

  const donorORData = useMemo(
    () => ({ donorHospitalTime, donorHospitalDate, donorHospitalTimeZone, displayDelay }),
    [donorHospitalTime, donorHospitalDate, donorHospitalTimeZone, displayDelay],
  );

  return {
    donorORData,
    formatedDelay,
    delayInfo,
  };
};
